/*
 * Slate-specific model types.
 */
export const MODEL_TYPES = {
    BLOCK: '@@__SLATE_BLOCK__@@',
    CHANGE: '@@__SLATE_CHANGE__@@',
    CHARACTER: '@@__SLATE_CHARACTER__@@',
    DOCUMENT: '@@__SLATE_DOCUMENT__@@',
    FRAGMENT: '@@__SLATE_DOCUMENT__@@',
    HISTORY: '@@__SLATE_HISTORY__@@',
    INLINE: '@@__SLATE_INLINE__@@',
    LEAF: '@@__SLATE_LEAF__@@',
    MARK: '@@__SLATE_MARK__@@',
    SELECTION: '@@__SLATE_SELECTION__@@',
    OPERATION: '@@__SLATE_OPERATION__@@',
    TEXT_RANGE: '@@__SLATE_TEXT_RANGE__@@',
    BLOCK_RANGE: '@@__SLATE_BLOCK_RANGE__@@',
    SCHEMA: '@@__SLATE_SCHEMA__@@',
    TEXT: '@@__SLATE_TEXT__@@',
    VALUE: '@@__SLATE_VALUE__@@',
};

/**
 * Export type identification function
 */
export function isType(type: string, input: any): boolean {
    return !!input?.[MODEL_TYPES[type]];
}
